import React from "react";
import { Box } from "@mui/material";
import { Container, Row, Grid } from '@mui/material';





function templeCard({ image, name }) {
    return (
        <>



            <Box className="templeCardBox">
                <img src={image} alt="" />
                <h3>{name}</h3>
            </Box>



        </>
    );
}


export default templeCard;